import "./SidebarLoading.css"

const SidebarLoading = ({ collapsed, isMobileView, isTabletView, toggled, itemCount = 6 }) => {
  // Don't show loading in mobile view
  if (isMobileView) {
    return null
  }

  // For tablet view when not toggled, show only icon loading
  const showOnlyIcons = isTabletView && !toggled

  // For collapsed desktop view, show only icon loading
  const showIconsOnly = collapsed || showOnlyIcons

  return (
    <div className="sidebar-loading">
      <ul>
        <li className="psb-menu-header">
          <span className="sidebar-header-text">{showIconsOnly ? "" : "Loading..."}</span>
        </li>
        {Array.from({ length: itemCount }).map((_, index) => (
          <li
            key={index}
            className="sidebar-loading-item"
            style={{
              listStyle: "none",
              borderRadius: "4px",
              transition: "all 0.3s ease",
              marginBottom: "8px",
            }}
          >
            <div
              className="sidebar-loading-content"
              style={{
                display: "flex",
                alignItems: "center",
                padding: showIconsOnly ? "15px 8px" : "10px 15px",
                borderRadius: "5px",
                justifyContent: showIconsOnly ? "center" : "flex-start",
                width: "100%",
                minHeight: "40px",
              }}
            >
              {/* Icon loading skeleton */}
              <div
                className="loading-icon-skeleton"
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "2px",
                  backgroundColor: "#e0e0e0",
                  animation: "pulse 1.5s ease-in-out infinite",
                }}
              />

              {/* Text loading skeleton - only show if not collapsed/tablet */}
              {!showIconsOnly && (
                <div
                  className="loading-text-skeleton"
                  style={{
                    marginLeft: "10px",
                    height: "16px",
                    backgroundColor: "#e0e0e0",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    width: `${Math.floor(Math.random() * 40) + 60}%`, // Random width between 60-100%
                  }}
                />
              )}
            </div>
          </li>
        ))}

        {/* Filters section loading */}
        <li className="psb-menu-header">
          <span className="sidebar-header-text">{showIconsOnly ? "" : "FILTERS"}</span>
        </li>

        {!showIconsOnly && (
          <li className="sidebar-loading-item">
            <div className="location-filter" style={{ padding: "0 15px" }}>
              <div
                className="loading-text-skeleton"
                style={{
                  height: "14px",
                  backgroundColor: "#e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                  width: "60px",
                  marginBottom: "10px",
                }}
              />
              <div
                className="loading-input-skeleton"
                style={{
                  height: "38px",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  animation: "pulse 1.5s ease-in-out infinite",
                  width: "100%",
                }}
              />
            </div>
          </li>
        )}
      </ul>
    </div>
  )
}

export default SidebarLoading
